import axios from 'axios';
import { API_BASE } from './apiBase';

// Accès aux services mini-site de public/apiEtsy.php (getMinisite, updateMinisiteParams,
// addMinisiteRsvp, getMinisiteRsvps, deleteMinisiteRsvp).
const API_URL = `${API_BASE}/apiEtsy.php`;
const CLE_API = '34KVHFQSP226YTk4n256QP6rGbqhA5w2ymY7W3pLwdbuc3i75';

export const minisiteGet = (service, params) =>
  axios.get(API_URL, { params: { cleApi: CLE_API, service, ...params } }).then((r) => r.data);

export const minisitePost = (service, body) =>
  axios.post(API_URL, body, { params: { cleApi: CLE_API, service } }).then((r) => r.data);

// Envoi d'une image (photo ou fond) : multipart/form-data, réservé au lien d'édition.
export const minisiteUpload = (fields, blob) => {
  const form = new FormData();
  Object.entries(fields).forEach(([key, value]) => form.append(key, value));
  form.append('image', blob, 'image.jpg');
  return axios.post(API_URL, form, { params: { cleApi: CLE_API, service: 'uploadMinisiteImage' } }).then((r) => r.data);
};

// Réduit une photo de téléphone (5-10 Mo) à un JPEG de quelques centaines de Ko AVANT l'envoi :
// plus rapide pour le client, et l'orientation de la photo est appliquée par le navigateur.
export const compressImage = (file, maxSide) => new Promise((resolve, reject) => {
  const url = URL.createObjectURL(file);
  const img = new Image();
  img.onload = () => {
    const ratio = Math.min(1, maxSide / Math.max(img.width, img.height));
    const canvas = document.createElement('canvas');
    canvas.width = Math.max(1, Math.round(img.width * ratio));
    canvas.height = Math.max(1, Math.round(img.height * ratio));
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = '#fff';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
    URL.revokeObjectURL(url);
    canvas.toBlob((blob) => (blob ? resolve(blob) : reject(new Error('compression impossible'))), 'image/jpeg', 0.85);
  };
  img.onerror = () => { URL.revokeObjectURL(url); reject(new Error('image illisible')); };
  img.src = url;
});
